import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Dashboard from '../components/admin/Dashboard';

const AdminDashboardPage = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Verifică dacă adminul este autentificat
    const token = localStorage.getItem('adminToken');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  return (
    <div className="admin-page">
      <Dashboard />
    </div>
  );
};

export default AdminDashboardPage;